import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import type {
  UserActionsRequest,
  UserActionResponse,
  UserActionsListResponse,
} from "../types/api/logs";

const path = `admin/${process.env.REACT_APP_API_VERSION}/moderators`;

// Действия модераторов - Получить список
export function fetchModeratorActions(
  params: UserActionsRequest
): Promise<UserActionsListResponse> {
  return mainAPI
    .get<UserActionResponse[]>(`analytics/${path}/actions`, { params })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}

// Действия модераторов - Экспортировать
export function exportModeratorLogs(
  format: string,
  filters: Omit<UserActionsRequest, "limit" | "offset"> = {}
) {
  return mainAPI
    .get(`analytics/${path}/actions/export`, {
      params: {
        format,
        ...filters,
      },
      responseType: "blob",
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        const apiError: ApiErrorResponse = error.response?.data;
        return Promise.reject(
          new Error(apiError?.detail || "Ошибка при экспорте логов")
        );
      }
    );
}
